import { IContextualMenuItem } from 'office-ui-fabric-react';

export const COMPONENT_MENU: IContextualMenuItem[] = [
    {
        key: 'Edit',
        icon: 'Edit',
        name: 'Edit'
    },
    {
        key: 'Delete',
        icon: 'Delete',
        name: 'Delete'
    },
];
export const COMPONENT_MENU_SINGLE_BRANCH: IContextualMenuItem[] = [
    {
        key: 'Edit',
        icon: 'Edit',
        name: 'Edit'
    },
];


// WEBPACK FOOTER //
// ./source/ts/constants/menus.ts